import i18n from '@/i18n.js'

export default {
  enablers: [],

  tableHeaders: [
    {text: 'Title', value: 'title'},
    {text: 'Key', value: 'aspect_key'},
    {text: 'Tenant', value: 'tenant_id'},
    {text: 'Type', value: 'enabler_type'},
    {text: 'Actions', value: 'actions', sortable: false}
  ],

  selectedEnabler: {},

  fields: [
    {
      name: 'title',
      type: 'text',
      label: 'Title',
      rules: [
        v => !!v || i18n.t('form_rules.mandatory')
      ],
      autofocus: true,
      required: true,
      hide: false,
      value: null,
      replicateValToIdx: 1
    },
    {
      name: 'aspect_key',
      type: 'slug',
      label: 'Key',
      rules: [
        v => !!v || i18n.t('form_rules.mandatory')
      ],
      required: true,
      hide: false,
      value: null,
      replicable: true,
    },
    {
      name: 'tenant_id',
      type: 'select',
      label: 'Tenant',
      items: [],
      itemText: 'title',
      itemValue: 'tenant_id',
      required: true,
      hide: false,
      chips: true,
      multiple: false
    },
    {
      name: 'enabler_type',
      type: 'text',
      label: 'Type',
      required: true,
      hide: false,
      value: null,
    },
    {
      name: 'enabler_params',
      type: 'textarea',
      label: 'Parameters (json)',
      required: true,
      hide: false,
      value: null,
    },
    {
      name: 'active',
      type: 'switch',
      label: i18n.t('active'),
      value: true,
      hide: false
    }
  ]
}
